export enum ActionType {
  ADDING_TERM = "Adding a term",
  DELETING_TERM = "Deleting a term",
  ADDING_KEYWORD = "Adding a Keyword",
  DELETING_KEYWORD = "Deleting a Keyword",
  DELETING_KEYWORD_IMAGE = "Deleting a Keyword image",
  TOGGLE_KEYWORD_IMAGE = "Toggle a Keyword image",
  SET_KEYWORD_IMAGE = "Set a Keyword image",
  SET_SEARCHED_IMAGES = "Set searched images",
  SET_CURRENT_SET_ID = "Set current set id",
  ADDING_SET = "Adding a set",
  DELETING_SET = "Deleting a set",
  SET_TERM_INFO = "Set term info",
  SET_SET_INFO = "Set set info",
  SET_KEYWORD_INFO = "Set keyword info",
  SAVE_CURRENT_SET = "Save current set",
  COPY_SAVED_SET = "Copy saved set",
  SET_ARE_IMAGES_LOADING = "Set are images loading",
  SET_LOADING = "Set loading",
  SET_SHOW_CONFIRM_MODAL = "Set show confirm modal",
  SET_SHOW_DEFINITION = "Set show definition",
  SET_ERROR = "Set error",
  SET_SUCCESS = "Set success",
  SET_IS_START_SIDE_FRONT = "Set is start card front",
  REORDER_TERMS = "Reorder terms",
  SET_SORTED_METHOD = "Set sorted method",
  TOGGLE_TERM_CATEGORY = "Toggle term category",
  LOGIN = "Login",
  LOGOUT = "Logout",
  GET_ALL_SETS = "Get all sets",
  CREATE_SET = "Create set",
  EDIT_SET = "Edit set",
  GET_SET = "Get set",
  DELETE_SET = "Delete set",
}
